import { render } from "./OfferItem.vue?vue&type=template&id=c272545c&scoped=true"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"

import "./OfferItem.vue?vue&type=style&index=0&id=c272545c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c272545c"]])

export default __exports__